// Kiti Rewards — custom Growave trigger
// Opens the Growave rewards popup from any element with
// data-kiti-rewards-trigger (or the .js-kiti-rewards class).
//
// Uses Growave's documented SDK shape and readiness events:
//   - window.gw.sdk                                       (SDK namespace)
//   - "gwSdkReady" event on document                      (SDK available)
//   - window.gw.sdk.common.events.WIDGET_INJECTED         (widget mounted)
//   - window.gw.sdk.runIfModuleReady(module, callback)    (per-module gate)
//   - window.gw.sdk.rewards.methods.openRewardsPopup()    (opens the popup)
// See docs.growave.io/docs/Sdk/modules/rewards/methods/openRewardsPopup

(function () {
  var pending = [];
  var rewardsReady = false;

  function flush() {
    while (pending.length) {
      var fn = pending.shift();
      try { fn(); } catch (err) { console.warn('[KitiRewards] handler failed', err); }
    }
  }

  function callOpenRewardsPopup() {
    window.gw.sdk.rewards.methods
      .openRewardsPopup()
      .catch(function (err) { console.warn('[KitiRewards] openRewardsPopup failed', err); });
  }

  function openRewards() {
    if (rewardsReady) {
      callOpenRewardsPopup();
      return;
    }
    pending.push(callOpenRewardsPopup);
  }

  function onRewardsWidgetInjected() {
    var REWARDS = window.gw.sdk.common.constants.modules.REWARDS;
    window.gw.sdk.runIfModuleReady(REWARDS, function () {
      rewardsReady = true;
      flush();
    });
  }

  // Hide the default floating launcher the moment Growave mounts it.
  // We can't disable it in the admin (that would also disable the popup),
  // and Growave renders the launcher inside a shadow root, so document-level
  // CSS cannot reach it. Instead we inject a scoped <style> tag inside each
  // Growave shadow root and also hide any matching button directly.
  var LAUNCHER_HIDE_CSS =
    '.gw-rd-popup-widget-launcher,' +
    '.gw-rd-popup-widget-launcher-btn,' +
    '[class*="gw-rd-popup-widget-launcher-btn"],' +
    '[class*="rd-popup-widget-launcher-btn"]' +
    '{display:none !important;visibility:hidden !important;}';

  function injectHideStyleInto(shadowRoot) {
    if (!shadowRoot) return false;
    if (shadowRoot.getElementById && shadowRoot.getElementById('kiti-launcher-hide-style')) {
      return true;
    }
    try {
      var style = document.createElement('style');
      style.id = 'kiti-launcher-hide-style';
      style.textContent = LAUNCHER_HIDE_CSS;
      shadowRoot.appendChild(style);
      // Also directly hide any launcher button already present.
      var btn = shadowRoot.querySelector(
        '.gw-rd-popup-widget-launcher, .gw-rd-popup-widget-launcher-btn, [class*="rd-popup-widget-launcher-btn"]'
      );
      if (btn) btn.style.display = 'none';
      return true;
    } catch (err) {
      console.warn('[KitiRewards] shadow-root style injection failed', err);
      return false;
    }
  }

  function sweepShadowRoots() {
    // Walk likely Growave container elements (and a broader [class^="gw-"]
    // net) looking for open shadow roots, then inject the hide rule into each.
    var hosts = document.querySelectorAll(
      '.gw-rd-popup-widget-placeholder, ' +
      '[class*="gw-widget-placeholder"], ' +
      '[class*="gw-rd-popup-widget"], ' +
      '[class^="gw-"], ' +
      '[class*="growave"]'
    );
    var hit = false;
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) {
        if (injectHideStyleInto(hosts[i].shadowRoot)) hit = true;
      }
    }
    return hit;
  }

  function hideLauncherElement(detail) {
    // First, try the event payload's own element reference.
    var el = detail && (detail.element || detail.rootElement || detail.node);
    if (!el && detail && (detail.elementId || detail.id)) {
      el = document.getElementById(detail.elementId || detail.id);
    }
    if (el && el.shadowRoot) {
      injectHideStyleInto(el.shadowRoot);
    } else if (el && el.classList) {
      el.classList.add('kiti-rewards-launcher-hidden');
    }
    // Always sweep the document for other shadow hosts — Growave sometimes
    // mounts the launcher in a sibling/ancestor of the event payload node.
    sweepShadowRoots();
  }

  // A MutationObserver catches shadow hosts that mount after our initial sweep
  // (common on SPA-style theme transitions and lazy-loaded sections).
  function startShadowObserver() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () {
      sweepShadowRoots();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // Stop observing after 30 seconds to avoid unbounded work.
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  function onSdkReady() {
    var WIDGET_INJECTED = window.gw.sdk.common.events.WIDGET_INJECTED;
    window.gw.sdk.on(WIDGET_INJECTED, function (event) {
      if (!event || !event.detail) return;
      var name = event.detail.widgetName || '';
      if (name === 'RewardsPopUpWidget') {
        onRewardsWidgetInjected();
      } else if (/launcher/i.test(name)) {
        // Any widget whose name contains "Launcher" is treated as the floating
        // button and hidden. Covers RewardsLauncherWidget and any variants.
        hideLauncherElement(event.detail);
      }
    });
  }

  // If Growave mounted the launcher before our listener attached, sweep for
  // any shadow roots that might contain it. The observer below also keeps
  // watching in case the host mounts later.
  function sweepLauncherOnce() {
    sweepShadowRoots();
    hideLauncherElement({});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sweepLauncherOnce();
      startShadowObserver();
    });
  } else {
    sweepLauncherOnce();
    startShadowObserver();
  }

  if (window.gw && window.gw.sdk) {
    onSdkReady();
  } else {
    document.addEventListener('gwSdkReady', onSdkReady);
  }

  // Expose a single global so anything else in the theme can call it.
  window.openKitiRewards = openRewards;

  // Delegated click handler — any element in the DOM with the data attr, class,
  // or an <a href="#kiti-rewards"> triggers the popup. The href variant lets the
  // user add Kiti Rewards to a Shopify menu from the admin without code edits.
  document.addEventListener('click', function (event) {
    var target = event.target.closest(
      '[data-kiti-rewards-trigger], .js-kiti-rewards, a[href="#kiti-rewards"], a[href$="/#kiti-rewards"]'
    );
    if (!target) return;
    event.preventDefault();
    openRewards();
  });
})();
